import { TUserRole } from '@/types';
import { setUrlSearchParam } from '@/utilities';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUserStore = defineStore('user', () => {
  const currentUser = ref(null);
  const isAuthenticated = ref(false);
  const isPlayScout = ref(true);
  const isClockScout = ref(true);
  // true while a silent token renewal attempt is in flight/being retried
  const isRecoveringAuth = ref(false);

  const setAuth = (val: boolean) => {
    isAuthenticated.value = val;
  };

  const setRecoveringAuth = (val: boolean) => {
    isRecoveringAuth.value = val;
  };

  const setCurrentUser = (user: any) => {
    currentUser.value = user;
    setAuth(true);
  };

  const setUserRole = (role: 'ALL' | 'CLOCK' | 'PLAYS') => {
    switch (role) {
      case 'PLAYS':
        isPlayScout.value = true;
        isClockScout.value = false;
        break;
      case 'CLOCK':
        isPlayScout.value = false;
        isClockScout.value = true;
        break;
      default:
        isPlayScout.value = true;
        isClockScout.value = true;
        break;
    }
    if (role) {
      setUrlSearchParam('role', role);
    }
  };

  const getUserRole = (): TUserRole => {
    if (!isPlayScout.value && isClockScout.value) return TUserRole.CLOCK;
    if (isPlayScout.value && !isClockScout.value) return TUserRole.PLAYS;
    return TUserRole.ALL;
  };

  return {
    currentUser,
    getUserRole,
    isAuthenticated,
    isClockScout,
    isPlayScout,
    isRecoveringAuth,
    setRecoveringAuth,
    setAuth,
    setCurrentUser,
    setUserRole,
  };
});
